import React from "react"
import ReactDOM from "react-dom"
import App from "./components/App"
// import Dashboard from "./components/Dashboard";
// import JssProvider from "react-jss/lib/JssProvider";
// import {create} from "jss";
// import {createGenerateClassName, jssPreset} from "@material-ui/core/styles";
// import {AppContainer} from "react-hot-loader";

// const generateClassName = createGenerateClassName();
// const jss = create({
//     ...jssPreset(),
//     // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
//     insertionPoint: "jss-insertion-point",
// });


// Render component into the DOM if the wrapper (element with app id) exists
const RenderApp = () => {
    const wrapper = document.getElementById("app");
    wrapper ? ReactDOM.render(
            <App
                endpoint={wrapper.getAttribute('data-param')}
                appName={wrapper.getAttribute('app-name')}
            />
        , wrapper
    ) : null;
};

RenderApp();
